module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-drawer', {
    attrs: {
      "title": "广告编辑修改",
      "size": "80%",
      "custom-class": "ads_edit",
      "visible": _vm.AdsEditDrawer,
      "before-close": _vm.handleClose,
      "direction": "btt"
    },
    on: {
      "update:visible": function($event) {
        _vm.AdsEditDrawer = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 20px"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "广告计划",
      "name": "AdsEditPanel"
    }
  }, [_c('EditPanelAds', {
    attrs: {
      "AdsForm": _vm.AdsForm
    },
    on: {
      "updateAds": _vm.updateAds,
      "update:AdsForm": function($event) {
        _vm.AdsForm = $event
      },
      "update:ads-form": function($event) {
        _vm.AdsForm = $event
      },
      "cancelAdsEditDrawer": _vm.cancelAdsEditDrawer
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "广告创意",
      "name": "CreativeEditPanel"
    }
  }, [_c('CreativeEditPanel', {
    ref: "creativeBody",
    attrs: {
      "AdsForm": _vm.AdsForm
    },
    on: {
      "updateAds": _vm.updateAds,
      "cancelAdsEditDrawer": _vm.cancelAdsEditDrawer,
      "update:AdsForm": function($event) {
        _vm.AdsForm = $event
      },
      "update:ads-form": function($event) {
        _vm.AdsForm = $event
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddb94462"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/edit/index.vue
// module id = 1110
// module chunks = 36